

export const frontMatter = {};
export const contentTitle = 'Intelligibility Builder';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-resources-applets-intelligibility-md-af9.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    header: "header",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, IntelligibilityBuilder} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!IntelligibilityBuilder) _missingMdxReference("IntelligibilityBuilder", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "intelligibility-builder",
        children: "Intelligibility Builder"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Construct a special notation to indicate the intelligibility of a given form in the Slavic languages. Drag and drop a synset XML file to the table below to get started (see ", _jsx(_components.a, {
        href: "https://raw.githubusercontent.com/medzuslovjansky/database/beta/synsets/00/00/01/oko.xml",
        children: "an example"
      }), "). After you finish with the table, hover over the code and click the \"Copy\" button to copy the code to your clipboard."]
    }), "\n", _jsx(IntelligibilityBuilder, {}), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

